export const References = [
  {
    id: 1,
    citation: "L. Guo, Cukic, & Singh, 2003",
    description:
      "Guo, L., Cukic, B., & Singh, H. (2003). Predicting Fault Prone Modules by the Dempster-Shafer Belief Networks. Proceedings of 18th IEEE International Conference on Automated Software Engineering (ASE'03), 249-252.",
    url: "http://doi.ieeecomputersociety.org/10.1109/ASE.2003.1240314",
  },
  {
    id: 2,
    citation: "N. L. Guo et al., 2011",
    description:
      "Guo, N. L., Wan, Y. W., Bose, S., Denvir, J., Kashon, M. L., & Andrew, M. E. (2011). A novel network model identified a 13-gene lung cancer prognostic signature. Int J Comput Biol Drug Des, 4(1), 19-39. doi:10.1504/IJCBDD.2011.038655",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/21330692",
  },
  {
    id: 3,
    citation: "N. L. Guo & Wan, 2012",
    description:
      "Guo, N. L., & Wan, Y. W. (2012). Pathway-based identification of a smoking associated 6-gene signature predictive of lung cancer risk and survival. Artif Intell Med, 55(2), 97-105. doi:10.1016/j.artmed.2012.01.001",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/22326768",
  },
  {
    id: 4,
    citation: "Ye, Singh, Qian, & Guo, 2021",
    description:
      "Ye, Q., Singh, S., Qian, P. R., & Guo, N. L. (2021). Immune-Omics Networks of CD27, PD1, and PDL1 in Non-Small Cell Lung Cancer. Cancers (Basel), 13(17). doi:10.3390/cancers13174296",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/34503105",
  },
  {
    id: 5,
    citation: "Ye, Falatovich, et al., 2021",
    description:
      "Ye, Q., Falatovich, B., Singh, S., Ivanov, A. V., Eubank, T. D., & Guo, N. L. (2021). A Multi-Omics Network of a Seven-Gene Prognostic Signature for Non-Small Cell Lung Cancer. Int J Mol Sci, 23(1). doi:10.3390/ijms23010219",
    url: "https://pubmed.ncbi.nlm.nih.gov/35008645/",
  },
  {
    id: 6,
    citation: "Heath et al., 2021",
    description:
      "Heath, A. P., Ferretti, V., Agrawal, S., An, M., Angelakos, J. C., Arya, R., . . . Grossman, R. L. (2021). The NCI Genomic Data Commons. Nat Genet, 53(3), 257-262. doi:10.1038/s41588-021-00791-5",
    url: "https://pubmed.ncbi.nlm.nih.gov/33619384/",
  },
  {
    id: 7,
    citation: "de Bruijn et al., 2023",
    description:
      "de Bruijn, I., Kundra, R., Mastrogiacomo, B., Tran, T. N., Sikina, L., Mazor, T., . . . Schultz, N. (2023). Analysis and Visualization of Longitudinal Genomic and Clinical Data from the AACR Project GENIE Biopharma Collaborative in cBioPortal. Cancer Res, 83(23), 3861-3867. doi:10.1158/0008-5472.CAN-23-0816",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/37668528",
  },
  {
    id: 8,
    citation: "Gao et al., 2013",
    description:
      "Gao, J., Aksoy, B. A., Dogrusoz, U., Dresdner, G., Gross, B., Sumer, S. O., . . . Schultz, N. (2013). Integrative analysis of complex cancer genomics and clinical profiles using the cBioPortal. Sci Signal, 6(269), pl1. doi:10.1126/scisignal.2004088",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/23550210",
  },
  {
    id: 9,
    citation: "Cerami et al., 2012",
    description:
      "Cerami, E., Gao, J., Dogrusoz, U., Gross, B. E., Sumer, S. O., Aksoy, B. A., . . . Schultz, N. (2012). The cBio cancer genomics portal: an open platform for exploring multidimensional cancer genomics data. Cancer Discov, 2(5), 401-404. doi:10.1158/2159-8290.CD-12-0095",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/22588877",
  },
  {
    id: 10,
    citation: "N. L. Guo et al., 2018",
    description:
      "Guo, N. L., Dowlati, A., Raese, R. A., Dong, C., Chen, G., Beer, D. G., . . . Qian, Y. (2018). A Predictive 7-Gene Assay and Prognostic Protein Biomarkers for Non-small Cell Lung Cancer. EBioMedicine, 32, 102-110. doi:10.1016/j.ebiom.2018.05.025",
    url: "https://pubmed.ncbi.nlm.nih.gov/29861409/",
  },
  {
    id: 11,
    citation: "Zhan et al., 2014",
    description:
      "Zhan, C., Zhang, Y., Ma, J., Wang, L., Jiang, W., Shi, Y., & Wang, Q. (2014). Identification of reference genes for qRT-PCR in human lung squamous-cell carcinoma by RNA-Seq. Acta Biochim Biophys Sin (Shanghai), 46(4), 330-337. doi:10.1093/abbs/gmt153",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/24457517",
  },
  {
    id: 12,
    citation: "Walter et al., 2016",
    description:
      "Walter, R. F., Werner, R., Vollbrecht, C., Hager, T., Flom, E., Christoph, D. C., . . . Mairinger, F. D. (2016). ACTB, CDKN1B, GAPDH, GRB2, RHOA and SDCBP Were Identified as Reference Genes in Neuroendocrine Lung Cancer via the nCounter Technology. PLoS One, 11(11), e0165181. doi:10.1371/journal.pone.0165181",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/27802291",
  },
  {
    id: 13,
    citation: "Saviozzi et al., 2006",
    description:
      "Saviozzi, S., Cordero, F., Lo Iacono, M., Novello, S., Scagliotti, G. V., & Calogero, R. A. (2006). Selection of suitable reference genes for accurate normalization of gene expression profile studies in non-small cell lung cancer. BMC Cancer, 6, 200. doi:10.1186/1471-2407-6-200",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/16872493",
  },
  {
    id: 14,
    citation: "Chang et al., 2018",
    description:
      "Chang, Y. C., Ding, Y., Dong, L., Zhu, L. J., Jensen, R. V., & Hsiao, L. L. (2018). Differential expression patterns of housekeeping genes increase diagnostic and prognostic value in lung cancer. PeerJ, 6, e4719. doi:10.7717/peerj.4719",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/29761043",
  },
  {
    id: 15,
    citation: "Broad, 2024",
    description:
      "Broad. (2024). DepMap 24Q4 Public Retrieved from: doi:10.6084/m9.figshare.19700056.v2",
    url: "https://doi.org/10.6084/m9.figshare.19700056.v2",
  },
  {
    id: 16,
    citation: "Ghandi et al., 2019",
    description:
      "Ghandi, M., Huang, F. W., Jane-Valbuena, J., Kryukov, G. V., Lo, C. C., McDonald, E. R., 3rd, . . . Sellers, W. R. (2019). Next-generation characterization of the Cancer Cell Line Encyclopedia. Nature, 569(7757), 503-508. doi:10.1038/s41586-019-1186-3",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/31068700",
  },
  {
    id: 17,
    citation: "Nusinow et al., 2020",
    description:
      "Nusinow, D. P., Szpyt, J., Ghandi, M., Rose, C. M., McDonald, E. R., 3rd, Kalocsay, M., . . . Gygi, S. P. (2020). Quantitative Proteomics of the Cancer Cell Line Encyclopedia. Cell, 180(2), 387-402.e316. doi:10.1016/j.cell.2019.12.023",
    url: "https://pubmed.ncbi.nlm.nih.gov/31978347/",
  },
  {
    id: 18,
    citation: "McFarland et al., 2018",
    description:
      "McFarland, J. M., Ho, Z. V., Kugener, G., Dempster, J. M., Montgomery, P. G., Bryan, J. G., . . . Tsherniak, A. (2018). Improved estimation of cancer dependencies from large-scale RNAi screens using model-based normalization and data integration. Nat Commun, 9(1), 4610. doi:10.1038/s41467-018-06916-5",
    url: "https://www.ncbi.nlm.nih.gov/pubmed/30389920",
  },
  {
    id: 19,
    citation: "Corsello et al., 2020",
    description:
      "Corsello, S. M., Nagari, R. T., Spangler, R. D., Rossen, J., Kocak, M., Bryan, J. G., . . . Golub, T. R. (2020). Discovering the anti-cancer potential of non-oncology drugs by systematic viability profiling. Nat Cancer, 1(2), 235-248. doi:10.1038/s43018-019-0018-6",
    url: "https://pubmed.ncbi.nlm.nih.gov/32613204/",
  },
];
